import { render, staticRenderFns } from "./UPUserStatus.vue?vue&type=template&id=504d7308&scoped=true"
import script from "./UPUserStatus.vue?vue&type=script&lang=js"
export * from "./UPUserStatus.vue?vue&type=script&lang=js"
import style0 from "./UPUserStatus.vue?vue&type=style&index=0&id=504d7308&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d7308",
  null
  
)

export default component.exports